import { useState } from "react";
import { createPortal } from "react-dom";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgThetaAi } from "@ugitgud/legos/ui/icon/SVG/ThetaAi";
import { useGlobalBanner } from "@ugitgud/legos/components/banner/BannerContainer";
import { CURRENT_ACTIVE_BANNER } from "@ugitgud/legos/hooks/useBanner";
import classnames from "classnames";

export const ThetaContainer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { openBannerIds } = useGlobalBanner();
  const isBannerOpen = openBannerIds.includes(CURRENT_ACTIVE_BANNER);

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  const topPosition = isBannerOpen ? 143 : 95;
  const bottomRailHeight = 100;
  const bottomRailGap = 16;
  const headerHeight = 36;
  const windowHeight = window.innerHeight - topPosition - bottomRailHeight - bottomRailGap - headerHeight;

  return (
    <div className="theta-container">
      <button
        onClick={toggleChatbot}
        className="cursor-pointer relative flex justify-center items-center rounded-[3px] border-color-[#ffffff38] bg-[#3273FA] w-[60px] h-[60px] hover:bg-[#1154DF]"
      >
        <Icon icon={<SvgThetaAi />} className="text-white w-[33px]" size="custom"></Icon>
        <span className="absolute flex justify-center items-center w-full h-full text-white text-xs font-bold">AI</span>
      </button>

      {isOpen &&
        createPortal(
          <div
            className={classnames(
              "theta-window fixed left-[87px] max-sm:bottom-0 max-sm:right-0 max-sm:left-0 max-md:left-[18px] max-sm:top-[10vh] max-sm:z-[9999] sm:z-[11] overflow-hidden",
              { "sm:top-[143px]": isBannerOpen, "sm:top-[95px]": !isBannerOpen },
            )}
          >
            <div className="bg-white rounded-t-lg p-2 flex items-center">
              <button onClick={toggleChatbot} className="text-gray-500 hover:text-gray-700 text-xl leading-none">
                ×
              </button>
            </div>
            <iframe
              src="https://integrate.thetaedgecloud.com/chatbot/cht66sn05u4mi9p44feh"
              className={classnames("w-[360px] max-sm:w-full")}
              style={{ height: `${windowHeight}px`, maxHeight: "446px" }}
              title="Theta AI Chatbot"
            />
          </div>,
          document.body,
        )}
    </div>
  );
};
